export const ConfirmationModalType = {
  "RED": 0,
  "ORANGE": 1
}